import { matchService } from '../../_services';

export const match_scoring = {
    namespaced: true,
    state: {
        role_model : '',
        data_chart: '',
        data_candidate: ''
    },
    getters: {
        
    },
    actions: {
        async getDataChart({ dispatch },params) {
            let data = await matchService.getDataChart(params);
            dispatch('setDataChart',data);
            return data;
        },
        /* eslint-disable */
        async getDataRoleModel({dispatch}, payload) {
            return await matchService.getDataRoleModel({
                id_departemen : payload
            });
        },
        async getDataHeader() {
            return await matchService.getDataDashboard();
        },
        async getDataCandidate({ dispatch },params) {
            let data = await matchService.getDataCandidate(params);
            dispatch('setDataCandidate',data);
            return data;
        },

        async getColor({ dispatch },params) {
            let data = await matchService.getColor(params);
            dispatch('setDataCandidate',data);
            return data;
        },

        async getDataCandidateFilter({ dispatch },params) {
            let data = await matchService.getDataCandidateFilter(params);
            dispatch('setDataChart',data);
            return data;
        },
        
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        },
        setRoleModel(state, payload){
            state.role_model = payload;
        },
        setDataChart(state, payload){
            state.data_chart = payload.data;
        },
        setDataCandidate(state, payload){
            state.data_candidate = payload.data;
        },

    }
};